import React, { useContext } from 'react';

import { OfferingsWrapper, OfferList, OfferingsItem, ContentHeaderText, SubOfferItem } from './OfferStyles';
import { OrangeBorder } from '../../Styles';
import { Container, Heading, GenericP } from 'commonStyles';
import { isMobileContext } from 'UtilityComponents/Util';
import DisplayContext from 'UtilityComponents/displayContext';
import { whatweOfferData } from '../../config';

const Offerings = () => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	const { list, heading } = whatweOfferData;
	return (
		<OfferingsWrapper id='Offerings'>
			<Container>
				<OrangeBorder />
				<Heading
					fontSize={`${isMobile ? '24px' : '40px'}`}
					marBt={`${isMobile ? '30px' : '10px'}`}>
					{heading}
				</Heading>
				<OfferList dir={isMobile ? 'column' : 'row'}>
					{list.map((item) => (
						<OfferingsItem key={item.title}>
							<ContentHeaderText>{item.title}</ContentHeaderText>
							<GenericP bottom_M={20}>{item.subtext}</GenericP>
							<ul>
								{item.advantage.map((item) => (
									<SubOfferItem key={item}>
										{item}
									</SubOfferItem>
								))}
							</ul>
						</OfferingsItem>
					))}
				</OfferList>
			</Container>
		</OfferingsWrapper>
	);
};

export default Offerings;
